export function loadCompanyTheme(company) {
  // 查找是否已存在该公司主题的 <link> 标签
  const existingLink = document.getElementById('theme-link');

  if (existingLink) {
    // 如果已经加载了同样的主题文件，直接返回，避免重复加载
    if (existingLink.getAttribute('data-theme') === company) {
      return;
    }

    // 如果存在其他主题文件，移除它
    existingLink.parentNode.removeChild(existingLink);
  }

  // 创建新的 <link> 标签，动态加载新的主题文件
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.id = 'theme-link'; // 给 <link> 标签加一个 id 以便后续操作
  link.href = `/static/theme/${company}.css`;  // 相对 public 或 dist 目录的路径
  link.setAttribute('data-theme', company);   // 使用 data-theme 来标识加载的公司主题
  document.head.appendChild(link);
}
